import _ from 'lodash'
import {PersianHelper} from "./PersianHelper";

export const AccountingHelper = {
    depositStatus: {
        SUCCESS: 'OK',
        CANCELED: 'NOK'
    },
    MFATypes: {
        GOOGLE_AUTHENTICATOR: 0,
        SMS: 1,
        EMAIL: 2
    },
    REGISTERType: {
        SMS: 0,
        EMAIL: 1
    },
    DEPOSIT_WAGE_EDGE: {
        MIN: 120,
        MAX: 4000
    },
    WITHDRAW_WAGE_EDGE: 100000,
    MIN_DEPOSIT: 15000,
    MAX_DEPOSIT: 25000000,
    MAX_WITHDRAW: 100000000,
    transactionType: {
        TRADE: 0,
        CHARGE: 1,
        FEE: 2,
        COMMISSION: 3,
        WITHDRAW: 4
    },
    transactionTypeTitles: {
        0: 'معامله',
        1: 'واریز وجه',
        2: 'کارمزد',
        3: 'هدیه',
        4: 'برداشت وجه',
    },
    transactionStatus: {
        CANCELLED: 0,
        PENDING: 1,
        CONFIRMED: 2,
        DONE: 3,
        ONPROCESS: 4,
        REJECT: 5
    },
    transactionStatusTitle: {
        0: 'لغو شده',
        1: 'در حال بررسی',
        2: 'تایید شده',
        3: 'انجام شده',
        4: 'در حال انجام',
        5: 'رد شده'
    },
    creditCardStatus: {
        REFUSED: 0,
        CHECKING: 1,
        APPROVED: 2,
        SUBMITTED: 3,
    },
    creditCardStatusTitle: {
        0: 'رد شده',
        1: 'در دست بررسی',
        2: 'تایید شده',
        3: 'در انتظار بررسی',
    },
    waitingForUpgradeStatus: {
        NOTAPPROVED: -1,
        NOTHING: 0,
        REQUESTED: 1,
        APPROVED: 2,
    },
    waitingForUpgradeStatusTitles: {
        '-1': 'NOTAPPROVED',
        '0': 'NOTHING',
        '1': 'REQUESTED',
        '2': 'APPROVED',
    },
    generatePassword,
    cleanMailAddress,
    manipulateExtraData,
    calculateDepositWage,
    calculateWithdrawWage,
    bankProviders: {
        VANDAR: 5,
        ZIBAL: 6,
        JIBIMO: 7,
        PAYPING: 8,
        JIBIT: 9
    },
    FIRST_PLAN: 0,
    MIDDLE_PLAN: 1,
    LAST_PLAN: 1,
    depositType: {
        card: 0,
        iban: 1
    },
    notificationContentType: {
        trading: 38,
        campaign_register: 82,
        campaign_action: 84
    }
}

function generatePassword() {
    let length = 8,
        charset = 'abcdefghijklmnopqrstuvwxyz0123456789',
        retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
}

function cleanMailAddress(address) {
    return _.trim(address.toLowerCase())
}

/**
 * Manipulate transaction extra to normal form
 * ## IF TRANSACTION TYPE IS WITHDRAW, FUNCTION INSERT ARRAY OF OBJECTS INTO EXTRA ##
 *
 * @param transaction
 */
function manipulateExtraData(transaction) {
    let extras = {
        reference: '',
        card_number: '',
        amount: '',
        paid_at: '',
    }
    try {
        if (transaction) {
            if (transaction.type === AccountingHelper.transactionType.CHARGE) {
                if (transaction?.bank_extras) {
                    transaction.bank_extras = PersianHelper.toJSON(transaction.bank_extras)

                    switch (transaction.bank_provider) {
                        case AccountingHelper.bankProviders.VANDAR:
                            extras = {
                                reference: transaction.bank_extras.transId,
                                card_number: transaction.bank_extras.cardNumber,
                                amount: transaction.bank_extras.amount,
                                paid_at: transaction.bank_extras.paymentDate
                            }
                            break;

                        case AccountingHelper.bankProviders.ZIBAL:
                            extras = {
                                reference: transaction.bank_extras.refNumber,
                                card_number: transaction.bank_extras.cardNumber,
                                amount: transaction.bank_extras.amount,
                                paid_at: transaction.bank_extras.paidAt
                            }
                            break;

                        case AccountingHelper.bankProviders.JIBIMO:
                            extras = {
                                reference: transaction.bank_extras.trace_number,
                                card_number: transaction.bank_extras.card_number,
                                amount: transaction.bank_extras.original_amount,
                                paid_at: transaction.bank_extras.verified_at
                            }
                            break;

                        case AccountingHelper.bankProviders.JIBIT:
                            extras = {
                                reference: transaction.bank_extras.pspTraceNumber,
                                card_number: transaction.bank_extras.pspMaskedCardNumber,
                                amount: transaction.bank_extras.amount,
                                paid_at: transaction.bank_extras.verifiedAt
                            }
                            break;
                    }

                    transaction.extras = extras
                }
            } else if (transaction.type === AccountingHelper.transactionType.WITHDRAW) {
                if (transaction?.withdraw) {
                    let withdraw = transaction.withdraw

                    if(typeof withdraw?.reference_id !== 'undefined' && withdraw?.reference_id && withdraw?.reference_id !== '') {
                        extras = {
                            reference: withdraw?.reference_id,
                            amount: withdraw.amount - withdraw.fee,
                            paid_at: transaction.created_at
                        }
                    } else {
                        switch (transaction.bank_provider) {
                            case AccountingHelper.bankProviders.PAYPING:
                                extras = []
                                withdraw.extra?.settlements.map(withdrawItem => {
                                    extras.push({
                                        reference: withdrawItem.settlementCode,
                                        amount: transaction.amount,
                                        paid_at: transaction.created_at
                                    })
                                })
                                break;

                            case AccountingHelper.bankProviders.JIBIMO:
                                extras = []
                                withdraw.extra?.items.map(withdrawItem => {
                                    extras.push({
                                        reference: withdrawItem.batch.id,
                                        amount: withdrawItem.amount / 10,
                                        paid_at: withdrawItem.created_at
                                    })
                                })
                                break;

                            case AccountingHelper.bankProviders.JIBIT:
                                extras = {
                                    reference: transaction.id,
                                    amount: withdraw.extra.totalAmountTransferred / 10,
                                    paid_at: transaction.created_at
                                }
                                break;

                            default:
                                if (_.isArray(withdraw.extra)) {
                                    extras = []
                                    withdraw.extra.map(withdrawItem => {
                                        extras.push({
                                            reference: withdrawItem.iban_id,
                                            amount: withdrawItem.amount_toman,
                                            paid_at: withdrawItem.settlement_done_time_prediction
                                        })
                                    })
                                } else {
                                    extras = {
                                        reference: withdraw.extra.data.id,
                                        amount: withdraw.extra.data.amount / 10,
                                        paid_at: withdraw.extra.data.persianPredictedCheckoutDat,
                                    }
                                }
                                break;
                        }
                    }

                    transaction.extras = extras
                }
            }
        }
    } catch (e) {
        // Nothing need to do
    }
}

function calculateDepositWage(amount) {
    let finalAmount = parseInt(amount * (0.02 / 100))

    if (amount === 0) {
        return 0
    } else if (finalAmount < AccountingHelper.DEPOSIT_WAGE_EDGE.MIN) {
        return AccountingHelper.DEPOSIT_WAGE_EDGE.MIN
    } else if (finalAmount > AccountingHelper.DEPOSIT_WAGE_EDGE.MAX) {
        return AccountingHelper.DEPOSIT_WAGE_EDGE.MAX
    } else {
        return finalAmount
    }
}

function calculateWithdrawWage(amount) {
    return amount < AccountingHelper.WITHDRAW_WAGE_EDGE
        ? amount * (1.01 / 100)
        : 4000;
}
